import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 8px;
`;

export const List = styled('div')`
    position: relative;
    display: flex;
    flex-direction: column;
    width: calc(100% + 16px);
    padding: 0 8px;
    margin-left: -8px;
    gap: 16px;
    max-height: 300px;
    overflow: auto;

    > * {
        flex-shrink: 0;
    }
`;

export const FinderEmptyState = styled('div')`
    display: flex;
    justify-content: center;
    padding: 20px 32px;
`;
